function getContext() {
  if (!window || !window.localStorage) {
    throw new Error("Window or LocalStorage doesn't exist")
  }
  return window.localStorage
}
const getItem = (keyName) => {
  const context = getContext()
  const item = context.getItem(keyName)
  return item || ''
}
const setItem = (keyName, keyValue) => {
  const context = getContext()
  context.setItem(keyName, keyValue)
}
const removeItem = (keyName) => {
  const context = getContext()
  context.removeItem(keyName)
}
export const localStorageGateway = {
  getItem,
  setItem,
  removeItem,
}
export default localStorageGateway
